import FileInformationModal from './FileInformationModal.component';

export default FileInformationModal;